import React from 'react';
import queryString from 'query-string';
import * as XLSX from 'xlsx';

import CONSTANT from './../../../constant';
import Header from './../../../component/common/AdminHeader';
import Paging from './../../../component/common/Paging';
import UserList from './../../../component/user/List';

import { searchUsers } from './../../../actions/UserAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        this.state = {
            keyword: params.k,
            page: 1,
            limit: 50,
            list: undefined,
            count: 0
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        const { page, list, keyword } = this.state;
        return (
            <div className="container-fluid mb-3">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Search result</h1>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div className="d-inline-block mr-3">Search result for <strong><i>{keyword}</i></strong> keyword</div>
                                <button onClick={this.downloadExcel} className="btn btn-sm submit-button d-inline-block">
                                    <i className="fa fa-download mr-2" />
                                    Download Excel
                                </button>
                            </div>
                            <div className="col-md-6">
                                <form method="GET" action={CONSTANT.component.adminSearchUser.url}>
                                    <i className="fa fa-search d-inline-block" />
                                    <input type="text" name="k" className="form-control search-bar d-inline-block" placeholder="Search by employee no, designation and department" />
                                </form>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <UserList list={list} />
                                </div>
                            </div>
                        </div>
                        {
                            list !== undefined && <Paging page={page} listItem={list} onPageChange={this.changePage} />
                        }
                    </div>
                </div>
            </div>
        )
    }

    loadList = () => {
        const { keyword, page, limit } = this.state;
        searchUsers(keyword, page, limit).then((res: any) => {
            this.setState({
                list: res.result.list,
                count: res.result.count
            });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => { this.loadList() });
    }

    downloadExcel = (e: any) => {
        this.setState({ showLoader: true });
        const { keyword, count } = this.state;
        searchUsers(keyword, 1, count).then((res: any) => {
            this.setState({ showLoader: false });
            let date = new Date();
            let filename = `report-${date.getTime()}.xlsx`;

            let dataToExport: any = [];
            var ws_name = "Sheet1";
            res.result.list.map(function (item: any) {
                delete item.code;
                delete item.modifiedOn;
                delete item.userTypeName;
                delete item.loginStatusName;

                dataToExport.push({
                    ...item,
                });
            });
            var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(dataToExport);
            XLSX.utils.book_append_sheet(wb, ws, ws_name);
            XLSX.writeFile(wb, filename);
        });
    }
}

export default ComponentName;